export default {
    sim_provider_delete_title: "Eliminar proveedor SIM",
    sim_provider_delete_success_message: "Se ha eliminado el proveedor de SIM",
    sim_provider_delete_error_message: "No es posible borrar el proveedor SIM",
    sim_provider_delete_confirm_message: "¿Está seguro de que desea eliminar el proveedor SIM?",
    sim_provider_delete_package_in_use: "El proveedor de sim está vinculado a alguna cuenta de proveedor de sim por lo que no es posible eliminarlo"
}